"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

const SUPPORT_PHONE = process.env.NEXT_PUBLIC_SUPPORT_PHONE?.trim();

export function Footer() {
  const t = useTranslations("Footer");

  return (
    <footer className="border-t border-teal-primary/20 py-12 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3 className="text-slate-200 font-semibold text-sm mb-3">{t("legal")}</h3>
          <nav className="flex flex-col gap-2">
            <Link
              href="/privacy"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("privacy")}
            </Link>
            <Link
              href="/terms"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("terms")}
            </Link>
            <Link
              href="/refund-policy"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("refund")}
            </Link>
            <Link
              href="/contact"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("contact")}
            </Link>
          </nav>
        </div>
        <div>
          <h3 className="text-slate-200 font-semibold text-sm mb-3">{t("product")}</h3>
          <nav className="flex flex-col gap-2">
            <Link
              href="/research"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("research")}
            </Link>
            <Link
              href="/start"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("firstSession")}
            </Link>
            <Link
              href="/#how-it-works"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("howItWorks")}
            </Link>
            <Link
              href="/#product-demo"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("film")}
            </Link>
            <Link
              href="/product"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("download")}
            </Link>
            <Link
              href="/pricing"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("pricing")}
            </Link>
            <Link
              href="/subscribe"
              className="text-slate-400 hover:text-slate-100 text-sm transition-colors"
            >
              {t("subscribe")}
            </Link>
          </nav>
        </div>
        <div className="text-slate-400 text-sm space-y-1">
          <p>
            <a
              href="mailto:info@atabet.com"
              className="hover:text-slate-100 transition-colors"
            >
              info@atabet.com
            </a>
          </p>
          {SUPPORT_PHONE ? (
            <p>
              <a
                href={`tel:${SUPPORT_PHONE.replace(/\s/g, "")}`}
                className="hover:text-slate-100 transition-colors"
              >
                {SUPPORT_PHONE}
              </a>
            </p>
          ) : null}
          <p className="text-slate-500 text-xs">{t("supportHours")}</p>
          <p>
            {t("businessNature")}
            <br />
            BR: 70327165
          </p>
          <div className="pt-3">
            <LanguageSwitcher variant="footer" />
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-slate-700/50">
        <div className="compliance-footer text-slate-400 text-sm">
          <p>{t("copyright")}</p>
          <p>{t("address")}</p>
          <p>{t("brNumber")}</p>
          <p style={{ fontSize: 12, marginTop: 10, opacity: 0.8 }}>
            {t("disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}
